import PaperIcon from 'react-native-paper/lib/module/components/Icon'

// Just reexporting it here to make it easier to import
// Declaration is in /src/icon.d.ts
export const Icon = PaperIcon
